/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Intro_OfferInputs */



/**
* | output |
* | --- |
* | "Here's what you get: chat with models from OpenAI, Anthropic, Google, Mistral and more; ask questions across your files and connected tools like SharePoint, ..." |
*
* @param {Onboarding_Intro_OfferInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_intro_offer = /** @type {((inputs?: Onboarding_Intro_OfferInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Intro_OfferInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das bekommst du: Chats mit Modellen von OpenAI, Anthropic, Google, Mistral und mehr; Fragen über deine Dateien und angebundene Tools wie SharePoint, HubSpot oder Outlook; Dokumente und Präsentationen erstellen; und Projekte und Spaces mit deinem Team teilen.")
	return /** @type {LocalizedString} */ ("Here's what you get: chat with models from OpenAI, Anthropic, Google, Mistral and more; ask questions across your files and connected tools like SharePoint, HubSpot or Outlook; create documents and presentations; and share projects and spaces with your team.")
});